const awardSliderInit = () => {
	const options = {
		loop: true,
		speed: 1000,
		autoplay: true,
		pagination: {
			el: ".awardSlider__pagination",
			type: "progressbar",
		},
		navigation: {
			nextEl: ".awardSlider__btn--next",
			prevEl: ".awardSlider__btn--prev",
		},
	};

	const slideItems = document.querySelectorAll('.awardSlider .swiper-slide');

	if (slideItems.length) {
		if (slideItems.length === 1) {
			options.loop = false;
		}
		new Swiper('.awardSlider', options);
	}
};

awardSliderInit();
